import { render, staticRenderFns } from "./ConfigAreaInformation.vue?vue&type=template&id=4ec9603a&scoped=true"
import script from "./ConfigAreaInformation.vue?vue&type=script&lang=js"
export * from "./ConfigAreaInformation.vue?vue&type=script&lang=js"
import style0 from "./ConfigAreaInformation.vue?vue&type=style&index=0&id=4ec9603a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec9603a",
  null
  
)

export default component.exports